// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Dq3w","tabsBox":"styles_tabsBox__1L5LB","createButton":"styles_createButton__3l-4h"};